import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { ApplicationRootState } from 'types/app';

export const selectLanguage = (state: ApplicationRootState) =>
  state.language || initialState;

export const makeSelectLocale = () =>
  createSelector(selectLanguage, (languageState) => languageState.locale);
